import React from 'react'
import {Box, Flex, Text, Link} from '@primer/components'
import Image from './Image.js'
import InterHeading from '../components/InterHeading.js'

const Steps = ({
  link
}) => (
    <Box py={8} maxWidth="1280px" mx={"auto"}>
      <Flex as={Box} flexWrap={["Wrap", "Wrap", "Wrap", "noWrap"]}>
        <Flex.Item as={Box} width={[1, 1, 1, 1/3]} px={[3, 6, 8, "44px"]} mb={5}>
          <Flex.Item as={Box} width="72px" mx="auto">
            <Image src="https://user-images.githubusercontent.com/334891/57173355-75612e00-6dfc-11e9-8145-899adec58be5.png" width="100%"/>
          </Flex.Item>
          <InterHeading as="h3" textAlign="center" fontSize={3} my={2}>Sign up to participate</InterHeading>
          <Text as="p" fontSize={2} color="gray.6">
          When you sign up to join the program, we’ll ask you to fill out some information about yourself and how you do or don’t use GitHub. The information you provide will help our customer research team match you to particular studies.
          </Text>
          <Link href={link}>Sign up now →</Link>
        </Flex.Item>
        <Flex.Item as={Box} width={[1, 1, 1, 1/3]}  px={[3, 6, 8, "44px"]} mb={5}>
          <Flex.Item as={Box} width="72px" mx="auto">
            <Image src="https://user-images.githubusercontent.com/334891/57170446-c99aec80-6dc1-11e9-941a-3907400ea4b6.png" width="100%"/>
          </Flex.Item>
          <InterHeading as="h3" textAlign="center" fontSize={3} my={2}>Get invited</InterHeading>
          <Text as="p" fontSize={2} color="gray.6">
          From time to time, we’ll invite you to take part in a study. Almost all of our sessions take place online, which you can attend from the comfort of your home. Some of our studies may include incentives to participate like GitHub swag, gift cards, or donations to charities.
          </Text>
        </Flex.Item>
        <Flex.Item as={Box} width={[1, 1, 1, 1/3]} px={[3, 6, 8, "44px"]} mb={5}>
          <Flex.Item as={Box} width="72px" mx="auto">
            <Image src="https://user-images.githubusercontent.com/334891/57173363-890c9480-6dfc-11e9-91d2-38b38172ecb5.png" width="100%"/>
          </Flex.Item>
          <InterHeading as="h3" textAlign="center" fontSize={3} my={2}>Share your story</InterHeading>
          <Text as="p" fontSize={2} color="gray.6">
          You might be asked to share your experience with one of our products, tell us about how you work, test new designs, or complete a survey. Good or bad, we want to hear your feedback. By taking part in research, you’ll help us build and refine GitHub to better meet your needs.
          </Text>
        </Flex.Item>
      </Flex>
    </Box>
  )

  export default Steps